import { render, staticRenderFns } from "./JoiningCrewBritainBay2020.vue?vue&type=template&id=e628055e&scoped=true"
import script from "./JoiningCrewBritainBay2020.vue?vue&type=script&lang=js"
export * from "./JoiningCrewBritainBay2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e628055e",
  null
  
)

export default component.exports